const View = require('./Filter').default
const container = require('./container')

module.exports = container(View)
